import React from "react"
import { Link } from "gatsby"

export default ({ handle = "#", text = "Default Text", className = "" }) => {
  return (
    <Link
      to={`/${handle}`}
      className={` border-4 rounded-md border-blue-dark py-2 px-4 text-white bg-blue-dark hover:text-blue-dark hover:bg-white font-bold uppercase tracking-wider ${className}`}
    >
      {text}
    </Link>
  )
}
